import { useContext, useEffect, useRef, useState } from "react";
import "./pdfView.css";
import { Document, Page, pdfjs } from "react-pdf";
import { useParams } from "react-router-dom";
import {
  BasketHistory,
  BasketHistoryDeatils,
  SetNote,
  getProduct,
  getProductChildren,
  getProducts,
  mediaBaseUrl,
} from "../axios";

import { Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import iconv from "iconv-lite";
import { Buffer } from "buffer";

import {
  Icon,
  MinimalButton,
  Position,
  SpecialZoomLevel,
  Tooltip,
  Viewer,
} from "@react-pdf-viewer/core";
import {
  pageNavigationPlugin,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";

import disableScrollPlugin from "./disableScrollPlugin";
import ReactQuill from "react-quill";
import { BasketContext } from "../context/BasketProvider";
import { toast } from "react-toastify";
import Error404 from "../pages/Errors/Error404";
import persianToEnglishNumbers from "../tools/farsiToEnglishNumber";
import ReactPlayer from "react-player";
import PlaybackRate from "./common/PlaybackSpeed";
import PdfViewer from "./PdfViewer";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
export const enNumberConvertor = (e) => {
  let regex = new RegExp(/^\d+$/);
  let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (regex.test(str)) return true;
  e.preventDefault();
  return false;
};

let isMobile = (function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
})();
const PdfView = (id) => {
  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "color", // Add the 'color' format for changing text color
  ];
  const phoneNumber = localStorage.getItem("phonenumber");
  const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [children, setChildren] = useState([]);
  const [activeChild, setActiveChild] = useState(1);
  const [content, setContent] = useState("");
  const [fileUrl , setFileUrl] = useState(null);
  const [userAllowed, setUserAllowed] = useState(null);
  const { basketDetailsItems, getBasketHistory, basketHistoryStatus } =
    useContext(BasketContext);
  const pdfRef = useRef(null);

  //vioce related states and functions
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [voiceUrl, setVoiceUrl] = useState("");
  const playerRef = useRef(null);

  const handlePlaybackSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
  };

  const handleSeek = (seconds) => {
    const currentTime = playerRef?.current?.getCurrentTime();
    if (currentTime) {
      // console.log("Curent time", currentTime);

      playerRef?.current?.seekTo(currentTime + seconds, "seconds");
    }
  };

  const { GoToNextPage, GoToPreviousPage, jumpToPage, CurrentPageLabel } =
    pageNavigationPluginInstance;

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  let params = useParams();
  const [result, setResult] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const { data: products } = await getProducts();
      const filterProduct = products?.filter((p) => p.id == params.id);

      //if the product has children show them as seasons otherwise show the product as pdf
      if (filterProduct[0].isAsli === true && filterProduct[0].ParentId == 0) {
        const { data: productChildren } = await getProductChildren(
          filterProduct[0].id
        );

        if (productChildren.length > 0) {
          setChildren(productChildren);
          setResult(productChildren[0]);
        } else {
          setResult(filterProduct[0]);
        }
      } else {
        setResult(filterProduct[0]);
      }
    };

    fetchData();
  }, [params.id]);

  useEffect(() => {
    getBasketHistory();
  }, []);

  useEffect(() => {
    if (result) {
      // Delay for 2 seconds before creating the URL
      const timeoutId = setTimeout(() => {
        const fileUrl = `${mediaBaseUrl}${result?.fileasli}.pdf`;
        const voiceUrl = `${mediaBaseUrl}${result?.Voice}.mp3`;
        // console.log("media", mediaBaseUrl);
        // console.log("result", fileUrl);
        
        setVoiceUrl(voiceUrl)
        setFileUrl(fileUrl); // Assuming you have a state like `const [fileUrl, setFileUrl] = useState("");`
      }, 2000);
  
      // Cleanup timeout on component unmount or when `result` changes
      return () => clearTimeout(timeoutId);
    }
  }, [result]);
  

  async function fetchDataById(id) {
    const { data } = await BasketHistoryDeatils(id);
    return data;
  }

  // //checking if the user have purchased the product before to protect the route
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await BasketHistory(
          persianToEnglishNumbers(phoneNumber)
        );
        if (data) {
          const allBaskets = await Promise.all(
            data.map(async (item) => {
              const details = await BasketHistoryDeatils(item.id);
              return details;
            })
          );

          const nedeedBaskets = allBaskets
            .filter(
              (item) =>
                !item.data.every(
                  (product) =>
                    product.productCategoryID === 1 ||
                    product.productCategoryID === 4
                )
            )
            .flatMap((item) => item.data.map((product) => product));

          if (nedeedBaskets) {
            const isPurchased = nedeedBaskets.some(
              (item) => item.productID == params.id
            );
            setUserAllowed(isPurchased);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [params.id]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  // const handleEditorChange = (value) => {
  //   setContent(value);
  // };

  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   const ID = basketDetailsItems.filter((item) =>
  //     item?.data.some((innerItem) => innerItem.productID === Number(params.id))
  //   )[0]?.data[0]?.id;
  //   try {
  //     const buffer = iconv.encode(content, "utf8");
  //     const base64 = buffer.toString("base64");

  //     await SetNote(ID, base64);
  //     toast.success("یادداشت با موفقیت ثبت شد");
  //   } catch (error) {
  //     toast.error("مشکلی در یادداشت برداری پیش آمده");
  //   }
  // };

  // useEffect(() => {
  //   const item = basketDetailsItems
  //     .filter((item) =>
  //       item?.data.some(
  //         (innerItem) => innerItem.productID === Number(params.id)
  //       )
  //     )[0]
  //     ?.data[0]?.note?.split(" ")
  //     .join("+");
  //   const buffer = Buffer?.from(item || "", "base64");
  //   const text = iconv?.decode(buffer || "", "utf8");
  //   setContent(text || "");
  // }, [basketDetailsItems]);

  const styles = {
    section: {
      width: 200,
      "@media max-width: 400": {
        width: 300,
      },
      "@media orientation: landscape": {
        width: 400,
      },
    },
  };

  const handleChangeSeason = (item, index) => {
    if (index) setActiveChild(index);
    if (item) {
      // console.log(item);
      setResult({ ...item });
    }

    if (pdfRef?.current) {
      pdfRef.current.scrollIntoView({
        behavior: "smooth", // Smooth scrolling effect
        block: "center", // Align the player at the center of the viewport
      });
    }
  };

  useEffect(() => {
    document.body.addEventListener("contextmenu", (e) => e.preventDefault());

    return () => {
      document.body.addEventListener("contextmenu", (e) => e.preventDefault());
    };
  }, []);

  return (
    <>
      {userAllowed === null || basketHistoryStatus === "pending" ? (
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : userAllowed ? (
        <div className="pdfView-page">
          <div class="container-fluid season-btns-container">
            <div class="row pt-5">
              {children && children.length > 0 && (
                <div className="season-btns season-pdf col-12">
                  <div className="seasons-title">فصل ها</div>
                  <div className="row">
                    {children.map((product, index) => (
                      <div key={product.id} className="col-12 col-md-6">
                        <p
                          className={
                            activeChild === index + 1 ? "active m-0" : "m-0"
                          }
                          onClick={() => handleChangeSeason(product, index + 1)}
                        >
                          {product?.title}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className="pd-container"
            onContextMenu={(e) => e.preventDefault()}
          >
            {/* <div
              className=" controls"
              style={{ display: "flex", justifyContent: "space-around" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <GoToNextPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                      >
                        بعدی
                      </button>
                    }
                    content={() => "Next page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToNextPage>
              <CurrentPageLabel>
                {(props) => (
                  <>
                    <span>
                      صفحه {props.currentPage + 1} از {props.numberOfPages}
                    </span>
                  </>
                )}
              </CurrentPageLabel>
              <CurrentPageLabel>
                {(props) => (
                  <>
                    <span>صفحه</span>

                    <select
                      name="pages"
                      id="pages"
                      value={pageNumber}
                      onChange={(e) => {
                        setPageNumber(+e.target.value);
                        jumpToPage(+e.target.value);
                      }}
                      style={{ width: 100, margin: "0px 10px" }}
                    >
                      {props.numberOfPages &&
                        [...Array(props.numberOfPages).keys()].map((i) => (
                          <option key={i} value={i}>
                            {i}
                          </option>
                        ))}
                    </select>
                  </>
                )}
              </CurrentPageLabel> 
              <GoToPreviousPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                        // disabled={pageNumber === 1}
                      >
                        قبلی
                      </button>
                    }
                    content={() => "Previous page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToPreviousPage>
            </div> */}
            <PdfViewer fileUrl={fileUrl} result={result} phoneNumber={phoneNumber}/>
            {/* <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`}
            >
              <div
                ref={pdfRef}
                className={
                  result?.isOfoghi !== undefined &&
                  result?.isOfoghi !== null &&
                  result.isOfoghi === true
                    ? "rpv-core__viewer isOfoghi"
                    : "rpv-core__viewer"
                }
                style={{
                  height: "90%",
                  width: "85%",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 18,
                  margin: "0 auto",
                }}
              >
                <div className="water-mark-phoneNum-pdf">{phoneNumber}</div>
                {/* <form
                  className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-5 mt-md-1 order-last order-md-first"
                  onSubmit={handleFormSubmit}
                >
                  <ReactQuill
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        [{ font: [] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ color: [] }, { background: [] }],
                        [{ script: "super" }, { script: "sub" }],
                        [{ align: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image", "video"],
                        ["clean"],
                      ],
                    }}
                    style={{
                      width: "100%",
                      height: "300px",
                      direction: "rtl !important",
                      marginBottom: "45import PdfViewer from './PdfViewer';
px",
                    }}
                    direction="rtl"
                    value={content}
                    onChange={handleEditorChange}
                  />
                  <button
                    type="submit"
                    className="btn btn-primary btn-block custom-btn mt-60"
                  >
                    ثبت
                  </button>
                </form> 
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translate(-24px, -50%)",
                    zIndex: 1,
                  }}
                >
                  <GoToNextPage>
                    {(props) => (
                      <Tooltip
                        position={Position.BottomCenter}
                        target={
                          <MinimalButton onClick={props.onClick}>
                            <Icon size={16}>
                              <path d="M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5" />
                            </Icon>
                          </MinimalButton>
                        }
                        content={() => "Next page"}
                        offset={{ left: 0, top: 8 }}
                      />
                    )}
                  </GoToNextPage>
                </div>
                <div
                  style={{
                    left: 0,
                    position: "absolute",
                    top: "50%",
                    transform: "translate(24px, -50%)",
                    zIndex: 1,
                  }}
                >
                  <GoToPreviousPage>
                    {(props) => (
                      <Tooltip
                        position={Position.BottomCenter}
                        target={
                          <MinimalButton onClick={props.onClick}>
                            <Icon size={16}>
                              <path d="M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5" />
                            </Icon>
                          </MinimalButton>
                        }
                        content={() => "Previous page"}
                        offset={{ left: 0, top: 8 }}
                      />
                    )}
                  </GoToPreviousPage>
                </div>

                {fileUrl === "" || fileUrl === null ? (<p>لطفا صبور باشید</p>) : (
                  <Viewer
                    plugins={[
                      disableScrollPluginInstance,
                      pageNavigationPluginInstance,
                    ]}
                    defaultScale={SpecialZoomLevel.PageFit}
                    fileUrl={fileUrl}
                  />
                )}
              </div>
            </Worker> */}
            {/* <Document
            // renderMode="custom"
            scale={5}
            error={<div>An error occurred!</div>}
            file={
              result && result?.fileasli?.length
                ? result?.fileasli
                : result
                ? result?.filedemo
                : null
            }
            onLoadSuccess={onDocumentLoadSuccess}
            onContextMenu={(e) => e.preventDefault()}
            // className="pdf-contailner"
          >
            <Page
              size="A4"
              scale={5}
              error={<div>An error occurred!</div>}
              // style={styles.section}
              pageNumber={pageNumber}
              onContextMenu={(e) => e.preventDefault()}
            />
          </Document> */}
            {/* <div
              className="controls ctrl2"
              style={{ display: "flex", justifyContent: "space-around" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <GoToNextPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                      >
                        بعدی
                      </button>
                    }
                    content={() => "Next page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToNextPage>
              <GoToPreviousPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                        // disabled={pageNumber === 1}
                      >
                        قبلی
                      </button>
                    }
                    content={() => "Previous page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToPreviousPage>
            </div> */}
            {/* if there is a vioce atatched to the product show here */}
            {voiceUrl !== null &&
              voiceUrl !== undefined &&
              voiceUrl?.length > 0 && (
                <div className="container">
                  <ReactPlayer
                    className="w-100"
                    onContextMenu={(e) => e.preventDefault()}
                    ref={playerRef}
                    url={voiceUrl}
                    controls
                    playbackRate={playbackSpeed}
                    style={{ maxHeight: 100 }}
                    config={{
                      file: {
                        attributes: {
                          controlsList: "nodownload",
                        },
                      },
                    }}
                  />
                  <PlaybackRate
                    onPlaybackSpeedChange={handlePlaybackSpeedChange}
                    onSeek={handleSeek}
                  />
                </div>
              )}
          </div>
        </div>
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default PdfView;
